import React from "react";
import PropTypes from "prop-types";
import "../../../styles/button.scss";

const StylishButton = ({
  label,
  icon,
  width,
  disabled,
  className,
  textAlign,
  size,
  ...props
}) => {
  const classNames = [className, "stylish-button"];
  const contentClassNames = ["stylish-button-contents__label"];

  if (disabled) classNames.push("stylish-button--disabled");

  if (!textAlign && !icon) {
    contentClassNames.push("stylish-button-contents__label--align-center");
  }

  if (textAlign === "center") {
    contentClassNames.push("stylish-button-contents__label--align-center");
  }

  if (textAlign === "left") {
    contentClassNames.push("stylish-button-contents__label--align-left");
  }

  if (textAlign === "right") {
    contentClassNames.push("stylish-button-contents__label--align-right");
  }

  if (size === "small") {
    classNames.push("stylish-button--small");
  }

  return (
    <button
      type="button"
      className={classNames.join(" ")}
      style={{ width }}
      {...props}
    >
      <div className="stylish-button-contents">
        <div className={contentClassNames.join(" ")}>{label}</div>
      </div>
      <div className="stylish-button-trailing-content">
        <div className="stylish-button-trailing-content__icon">{icon}</div>
      </div>
    </button>
  );
};

StylishButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  textAlign: PropTypes.string,
  size: PropTypes.oneOf(["medium", "small"]),
};

StylishButton.defaultProps = {
  onClick: undefined,
  disabled: false,
};

export default StylishButton;
